<template>
  <nav class="d-sticky-menu menu sticky-menu show">
    <div
      ref="baseOptions"
      class="options"
    >
      <a
        v-if="subMenu"
        class="menu-entry"
        @click="openMobileMenu()"
      >
        <DuiIconMenu class="icon-lg" />
        <span class="valign-middle">Menu</span>
      </a>

      <slot name="options" />
    </div>

    <DMobileCard
      v-if="$slots['open-menu-options']"
      store-close-action="Cards/closeMobileMenu"
      store-display-key="Cards/get-mobile-menu-display-state"
    >
      <template slot="card-header">
        <h2>Menu</h2>
      </template>
      <template slot="card-body">
        <slot name="open-menu-options" />
      </template>
    </DMobileCard>
  </nav>
</template>

<script>
import DMobileCard from '@d-components/d-mobile-card/d-mobile-card.vue';

export default {
  components: {
    DMobileCard,
  },
  props: {
    subMenu: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openMobileMenu() {
      this.$store.dispatch('Cards/openMobileMenu');
    },
  },
};
</script>

<style lang="scss">
@import "@dui-styles/base";

.d-sticky-menu {
  .options {
    z-index: 0;

    .menu-entry .menu-entry-content {
      align-items: center;
      display: inline-flex;
      flex-direction: column;
    }
  }
}
</style>
